"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigInAbilityHandler = exports.DigInActorAbilityFactory = exports.DigInAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class DigInAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DigIn;
        this.__typeName = "DigIn";
    }
}
exports.DigInAbilityArgs = DigInAbilityArgs;
let DigInActorAbilityFactory = class DigInActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DigIn", "AllAllies", 0);
    }
};
DigInActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DigIn")
], DigInActorAbilityFactory);
exports.DigInActorAbilityFactory = DigInActorAbilityFactory;
let DigInAbilityHandler = class DigInAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(targetId => {
                    container.applyBuff({
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.LinkedEffectsEffectArgs([
                            new core_1.StunImmunityEffectArgs(),
                            new core_1.CharmImmunityEffectArgs(),
                        ], false),
                        sequence: sequence.pushSequence("sequential"),
                        onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "IceWindsPillar"))
                    });
                });
            },
        });
    }
};
DigInAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DigIn)
], DigInAbilityHandler);
exports.DigInAbilityHandler = DigInAbilityHandler;
